var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWindmill = function SvgWindmill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 27 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M12.526 25.158c0-.785.636-1.421 1.421-1.421v0c.785 0 1.421.636 1.421 1.42V28h-2.842z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "m10.75 16.631-1.776 7.106V28h9.947v-4.263l-.71-2.487"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "m6.131 3.175 2.175-2.174 6.352 6.352-2.175 2.174z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "m21.72 3.131 2.175 2.174-6.352 6.352-2.175-2.174zM13.215 14.543l2.174-2.174 6.352 6.352-2.174 2.174zM10.352 10.237l2.174 2.175-6.352 6.352L4 16.589zM19.276 5.619l-9.237 9.237M18.21 15.21 8.973 5.974M5.776 28h16.342"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M13.237 19.474h1.421v2.132h-1.421z"
  })));
};
export default SvgWindmill;